import React, { useState, useEffect } from 'react';
import ProductSearchBar from './../products/ProductSearchBar';
import ProductModal from '../products/ProductModal';
import FeaturedProducts from './../products/FeaturedProducts';
import ExpressOrder from '../orders/ExpressOrder';
import LastProducts from './../products/LastProducts';
import { useSelector, useDispatch } from 'react-redux';
import { FaSearch } from "react-icons/fa"; // Import de l'icône de loupe

import { useNavigate } from "react-router-dom";

import './home-main.css';
import { debug } from './../../utils';



const HomeMain = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const user = useSelector((state) => state.user);
  const config = useSelector((state) => state.config);
  const [showProductModal, setShowProductModal] = useState(false);


  const phoneNumber = useSelector((state) => state.config.config?.tenant?.front?.phone_number ?? null); // ← ajout
  const leguals_url = useSelector((state) => state.config.config?.tenant?.front?.leguals_url ?? null); // ← ajout
  const user_guide = useSelector((state) => state.config.config?.tenant?.front?.user_guide ?? null); // ← ajout


  const navigate = useNavigate();
  const handleProductSelect = (product) => {
    setSelectedProduct(product);
  };
  useEffect(() => {
    if (selectedProduct) {
      setShowProductModal(true);
    }
  }, [selectedProduct]);

  const handleCloseModal = () => {
    setSelectedProduct(null);
    setShowProductModal(false);
  };
  const handleAdvancedSearchClick = () => {
    navigate('/catalog')
  }
  return (
    <div id="home-main">
      <div className="page-title">
        <h1>Bienvenue dans l'extranet clients</h1>
      </div>
      <div className='top-section'>
        <ProductSearchBar onSelect={handleProductSelect} />
      </div>
      <div className='center-section pt-3'>
        <div className="container">
          <div className="row">
            {user && user?.catalogs?.includes('Kit') &&
              <div className="col col-md-8 col-12 mb-5 py-2">
                <div className="module">
                  <LastProducts onSelectProduct={handleProductSelect} />
                  {/* <FeaturedProducts onSelectProduct={handleProductSelect} /> */}
                </div>
              </div>
            }
            <div className="col col-md-4 col-12 mb-3 pt-2 right-side">
              <div className="module">
                <div className='text-center mx-auto'>
                  <div onClick={handleAdvancedSearchClick}>
                    <h5
                      className="rounded pointer"
                      title="Rechercher par constructeurs, modèles, etc"


                    >
                      <FaSearch size={28} style={{ with: '30px' }} /><span> Recherche avancée</span>
                    </h5>
                  </div>
                </div>       </div>

              {(user && user.orderEnabled !== "0" && user.catalogs?.includes('Faisceau')) &&
                <div className='module'>
                  <div className=' bg-light border rounded overflow-hidden '>
                    <ExpressOrder />
                  </div>
                </div>
              }
              {phoneNumber &&
                <div className=' module'>
                  <div className='py-3 px-4 bg-light border rounded text-center'>
                    Nous contacter :<br />
                    <strong className='fs-5 text-brand-primary'>{phoneNumber}</strong>
                  </div>
                </div>
              }

              {user_guide &&
                <div className=' module'>
                  <div className=' py-3 px-4 bg-light border rounded text-center '>
                    <a href={user_guide} className='text-brand-primary decoration-on-hover' target='_blank'>
                      Guide d'utilisation de la nouvelle version
                    </a>
                  </div>

                </div>
              }
              {leguals_url &&
                <div className=' module text-center'>
                  <a href={leguals_url} className='small decoration-on-hover' target='_blank'>
                    Mentions légales
                  </a>
                </div>
              }

            </div>


          </div>
        </div>
      </div>
      {showProductModal && <ProductModal product={selectedProduct} onClose={handleCloseModal} />}
      {debug(config.tenant)}
    </div >
  );
};

export default HomeMain;
